<template>
  <v-checkbox
    class="checkbox"
    color="primary"
    :label="labelComputed"
    :disabled="disabledComputed"
    v-model="model"
    @change="onChange"
    dense
  />
</template>

<script>
export default {
  name: 'Checkbox',
  components: {},

  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    labelComputed() {
      return this.label
    },
    disabledComputed() {
      return this.disabled
    },
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
<style>
/* ラベル色 */
.checkbox > .v-input__control > .v-input__slot > label {
  color: #000000;
}
.checkbox-inactive > .v-input__control > .v-input__slot > label {
  color: #a8a8a8;
}
</style>
